import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import DataCell from './DataCell';
import { density, getDensityClass } from './utils/density';

const styles = (/* theme */) => ({
  ...density
});

class GridTotals extends Component {

  computeTotals = (col, idx) => {
    const { settings } = this.props;
    const key = `footer-row-cell-${idx}`;
    if (col.visible) {
      if (!col.totals) {
        return <DataCell id={col.id} value="" key={key} settings={settings} />
      }
      const total = this.props.data.reduce((t, row) => t + parseFloat(row.data[col.id]), 0);

      return (
        <DataCell
          value={total}
          id={col.id}
          numeric
          key={key}
          settings={settings}
          currency={col.currency || false}
          dataCellProps={{
            style: {
              fontSize: 16,
              overflow: 'hidden'
            }
          }}
        />
      );
    }
    return null;
  };

  render() {
    const { columns, classes, settings } = this.props;

    return (
      <TableRow>
        <TableCell
          classes={{
            root: getDensityClass(classes, 'Cell', settings.density),
            paddingCheckbox: getDensityClass(classes, 'CheckboxCell', settings.density)
          }}
        >
          <Typography variant="subtitle1">
            Totals:
          </Typography>
        </TableCell>
        {columns.map(this.computeTotals)}
      </TableRow>
    )
  }
}

GridTotals.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default withStyles(styles)(GridTotals);
